// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__xIjIP","rootCenter":"LoadMoreObserver_rootCenter__2f38I","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3YMnO"};